<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />
      <div class="login-content block-column">
        <div class="login-detail">
          <div class="block-row">
            <div class="column-list" style="height: max-content;">
              <label class="list-input-title">認証コード</label>
              <div class="list-input-content">
                <input type="text" maxlength="6" plessInputTextSub [style.width.rem]="8"
                  [restrict]="'[ -￮]'" [(ngModel)]="model.confirmCode" [autofocus]="true" [tabindex]="0" />
              </div>
              <label class="list-input-title">新しいパスワード</label>
              <div class="list-input-content input-wrapper">
                <input id="txti_NewPassword" class="text-label-required" #txti_NewPassword
                  maxlength="30" plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="model.newPassword" [autofocus]="true"
                  [tabindex]="0" [type]="isPasswordVisible ? 'text': 'password'" autocomplete="off" />
                <button tabindex="-1" (mousedown)="eventEye_MouseDownHandler($event, 1)">
                  <fa-icon [icon]="iconEyeDisp"></fa-icon>
                </button>
              </div>
              <label class="list-input-title">新しいパスワード(確認)</label>
              <div class="list-input-content input-wrapper">
                <input id="txti_NewPasswordCheck" class="text-label-required" #txti_NewPasswordCheck maxlength="30" plessInputTextSub
                  [restrict]="'[ -￮]'" [(ngModel)]="model.newPasswordCheck" [autofocus]="true" [tabindex]="0" [type]="isPasswordVisible_check ? 'text': 'password'"
                  autocomplete="off" />
                <button tabindex="-1" (mousedown)="eventEye_MouseDownHandler($event, 2)">
                  <fa-icon [class]="isPasswordVisible_check ? 'fa-eye': 'fa-eye-slash'" [icon]="iconEyeDisp_check"></fa-icon>
                </button>
              </div>
            </div>
            <div>
              <h1>パスワード設定ルール</h1>
              <div class="block-column">
                <div class="message-box">
                  <label>①下記の4種類の文字を組み合わせて、<br>&emsp;8桁以上（半角）のパスワードをご設定ください。</label>
                  <label>&emsp;・英大文字（ABC...XYZ）</label>
                  <label>&emsp;・英小文字（abc...xyz）</label>
                  <label>&emsp;・数字（0123456789）</label>
                  <label>&emsp;・記号</label>
                </div>
                <label>②過去に設定したパスワードは使いまわしできません。<br>&emsp;※過去2世代以内に使用したパスワードは設定できません。</label>
              </div>
            </div>
          </div>
        </div>
        <div class="layout_balance">
          <button class="btn-tartiary" (click)="eventReturnHanler()">戻る</button>
          <button class="left-button" id="btn_update" class="btn-primary"
            (click)="eventUpdateHandler()" [tabindex]="0">更新</button>
        </div>
      </div>
  </div>
</div>
  